// material-ui
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Stack
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

interface SessionTimeoutDialogProps {
  handleLoginButton: () => void;
}

const SessionTimeoutDialog = ({
  handleLoginButton
}: SessionTimeoutDialogProps) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Dialog open={true} maxWidth='xs' fullWidth>
      <>
        <DialogTitle id='dialog-title'>
          {t('common.messages.sessionTimeoutDialogLabel')}
        </DialogTitle>
        <Divider
          sx={{
            opacity: 1,
            borderColor:
              theme.palette.mode === 'dark'
                ? theme.palette.dark.light + 15
                : theme.palette.grey[200]
          }}
        />
        <DialogContent>
          <Stack spacing={2}>
            {t('common.messages.sessionTimeoutDialogText')}
          </Stack>
        </DialogContent>

        <DialogActions sx={{ pr: 2.5 }}>
          <Button size='small' onClick={handleLoginButton}>
            {t(`common.button.login`)}
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
};

export default SessionTimeoutDialog;
